import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import Logo from '../../resources/images/logo/bizismart.png';
import { Button, CssBaseline, useMediaQuery } from '@mui/material';
import { useAuthContext } from '../../context/auth/AuthContext';
import { useSignOutContext } from '../../context/sign_out_context/SignOutContext';
import { StringKeys } from '../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import UnitedStatesFlag from '../../resources/images/flags/US.svg';
import SpanishFlag from '../../resources/images/flags/ES.svg';
import { UserStatus } from '../routes/routing_statuses/RoutingStatuses';

const CustomSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSelect-icon': {
    color: 'white',
  },
});

function LoadingNavBar({ showLoginButton }) {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const { clearAndSignOut } = useSignOutContext();
  const { t, i18n } = useTranslation();
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const defaultLanguage = 'en-US';
  const [language, setLanguage] = useState(() => {
    const currentLang = i18n.language || defaultLanguage;
    return currentLang.startsWith('en') ? 'en-US' : currentLang;
  });

  const changeLanguage = (lng) => {
    const normalizedLang = lng.startsWith('en') ? 'en-US' : lng;
    i18n.changeLanguage(normalizedLang);
    setLanguage(normalizedLang);
  };

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" style={{ background: 'black' }}>
          <Container maxWidth="xl">
            <Toolbar disableGutters>
            {isDesktop && (
              <img
                alt="BiziSmart"
                src={Logo}
                width="30"
                height="30"
                onClick={() => navigate('/')}
                style={{ cursor: 'pointer', marginRight:"10px" }}
              />
            )}

            <Typography
              variant="h6"
              sx={{ display: { xs: 'none', md: 'flex' }, fontWeight: 700, letterSpacing: '.3rem', color: 'inherit', cursor: 'pointer' }}
              onClick={() => navigate('/')}
            >
              BiziSmart
            </Typography>


              {/* Grow to fill space */}
              <Box sx={{ flexGrow: 1 }} />
              {/* Adjust Box for login/logout button */}
              <Box sx={{ display: 'flex', justifyContent: !isDesktop ? 'flex-end' : 'flex-end', alignItems: 'center' }}>
                <FormControl style={{ width: "140px" }} variant="outlined">
                  <CustomSelect
                    labelId="language-select-label"
                    value={language}
                    sx={{ color: "white", boxShadow: "none" }}
                    onChange={(e) => changeLanguage(e.target.value)}
                  >
                    <MenuItem value="en-US">
                      <img alt="United States" src={UnitedStatesFlag} style={{ width: '20px', height: '20px', borderRadius: '50%', objectFit: 'cover', marginRight: '10px' }} />
                      {t(StringKeys.ENGLISH)}
                    </MenuItem>
                    <MenuItem value="es">
                      <img alt="Spain" src={SpanishFlag} style={{ width: '20px', height: '20px', borderRadius: '50%', objectFit: 'cover', marginRight: '10px' }} />
                      {t(StringKeys.SPANISH)}
                    </MenuItem>
                  </CustomSelect>
                </FormControl>
                {user === UserStatus.UNAUTHENTICATED ? (
                  <>
                  {
                    showLoginButton && 
                      <Button
                        variant="contained"
                        onClick={() => navigate('/login')}
                        sx={{
                          textTransform: 'none',
                          color: 'white',
                          borderRadius: '30px',
                          marginLeft: !isDesktop ? 'auto' : '20px', 
                        }}
                        endIcon={<ChevronRight /> }
                      >
                        {t(StringKeys.LOG_IN)}
                      </Button>
                  }
                  </>
                ) : (
                  <Button
                    variant="contained"
                    onClick={() => {
                      clearAndSignOut(navigate);
                    }}
                    sx={{
                      textTransform: 'none',
                      color: 'white',
                      borderRadius: '30px',
                      marginLeft: !isDesktop ? 'auto' : '20px', // Float right on mobile
                    }}
                  >
                    {t(StringKeys.LOG_OUT)}
                  </Button>
                )}
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      </Box>
    </>
  );
}

export default LoadingNavBar;
